import DataTable from '@components/DataTable';
import type { Visibility } from '../MarketPerformance/styled';
import { TableWrapper } from '../MarketPerformance/styled';

import type { ChartData } from '../../hooks/useMarketPerformance';

interface Props {
  data: ChartData;
  tableVisibility: Visibility;
}
const MarketDataTable = ({ data, tableVisibility }: Props) => {
  return (
    <TableWrapper
      // if js is disabled, the SSR rendered chart has zero width, so make the table visible
      visibility={tableVisibility}
    >
      <DataTable data-cy-id="market-performance-data-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Market Cap</th>
            <th>Revenue</th>
            <th>Earnings</th>
            <th>PE</th>
            <th>Absolute PE</th>
            <th>PS</th>
          </tr>
        </thead>
        <tbody>
          {data.map(
            (
              {
                dateFormatted,
                marketCapFormatted,
                earningsFormatted,
                revenueFormatted,
                medianPEFormatted,
                absolutePEFormatted,
                psFormatted,
              },
              i
            ) => (
              <tr key={`${dateFormatted}-${i}`}>
                <td>{dateFormatted}</td>
                <td>{marketCapFormatted}</td>
                <td>{revenueFormatted}</td>
                <td>{earningsFormatted}</td>
                <td>{medianPEFormatted}</td>
                <td>{absolutePEFormatted}</td>
                <td>{psFormatted}</td>
              </tr>
            )
          )}
        </tbody>
      </DataTable>
    </TableWrapper>
  );
};

export default MarketDataTable;
